<template>
  <div class="app-content-wrapper">
    <div class="search-wrapper">
      <search-component ref="search"
                        :search-condition="searchCondition"
                        :search-buttons="searchButtonList"
                        router-name="/settlement/disbursement">
      </search-component>
    </div>
    <div class="table-wrapper">
      <custom-table :table-set="tableCondition"
                    :service-function="getList"
                    :first-parameters="getInitParams()"
                    ref="table"
                    router-name="/settlement/disbursement">
      </custom-table>
    </div>
  </div>
</template>
<script>
import { getDictionary } from '@/api/common';
import { ShowSuccessMessage } from '@/components/modal/tips/message-tips';
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component.vue';
import { initSelectedData } from '@/utils/tools/constant';
import { getTodayParams, initToday } from '@/utils/tools/time';
import DisbursementService from '@/views/settlement/api/disbursement';

export default {
  components: {
    CustomTable,
    SearchComponent,
  },
  data() {
    return {
      ...DisbursementService,
      downloading: false,
      searchCondition: [
        {
          key: 'payoutId',
          name: 'message.settlement.disbursementNo',
          type: 'input',
          defValue: '',
        },
        {
          key: 'payoutStatus',
          name: 'message.settlement.disbursementStatus',
          type: 'select',
          defValue: '',
          options: [],
        },
        {
          key: ['createTimeStartTime', 'createTimeEndTime'],
          name: 'message.settlement.disbursementCreatedAt',
          defValue: initToday(),
          type: 'date_time',
          required: true,
        },
        {
          key: ['payoutStartTime', 'payoutEndTime'],
          name: 'message.settlement.disbursementAt',
          defValue: ['', ''],
          type: 'date_time',
        },
      ],
      searchButtonList: [
        {
          type: 'download',
          name: 'message.settlement.export',
          permissionCode: 'settlement:disbursement:export',
          func: async (params) => {
            if (!this.downloading) {
              this.downloading = true;
              try {
                await this.exportDisbursement(params);
                ShowSuccessMessage(this.$t('message.common.downloadTask'));
              } catch (err) {
                //
              }
              this.downloading = false;
            }
          },
        },
      ],
      tableCondition: [
        {
          titleBar: { type: 'text', title: 'message.settlement.disbursementNo' },
          key: 'id',
          type: 'click',
          subTableDisplays: [
            {
              type: 'link',
              key: 'id',
              router: '/settlement/batch',
              isInternationalization: true,
              valueKey: ['id'],
              paramsKey: ['payoutId'],
            },
          ],
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.currency' },
          key: 'settleCurrency',
          type: 'text',
        },
        { // 结算金额
          titleBar: { type: 'text', title: 'message.settlement.settlementAmount' },
          key: 'settleSumAmount',
          type: 'text',
        },
        { // 出款手续费
          titleBar: { type: 'text', title: 'message.settlement.disbursementServiceCharge' },
          key: 'serviceFee',
          type: 'text',
        },
        { // 其它费用
          titleBar: { type: 'text', title: 'message.settlement.ortherExpenses' },
          key: 'otherFee',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.rate' },
          key: 'convRate',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.disbursementCurrency' },
          key: 'payoutCurrency',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.disbursementAmt' },
          key: 'payoutAmount',
          type: 'text',
        },
        // {
        //   titleBar: { type: 'text', title: 'message.settlement.payee' },
        //   key: 'payeeName',
        //   type: 'text',
        // },
        // {
        //   titleBar: { type: 'text', title: 'message.payee.bankName' },
        //   key: 'payeeBankName',
        //   type: 'text',
        // },
        {
          titleBar: { type: 'text', title: 'message.settlement.disbursementStatus' },
          key: 'payoutStatusName',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.disbursementDescription' },
          key: 'payoutTips',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.disbursementCreatedAt' },
          key: 'createTime',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.disbursementAt' },
          key: 'payoutTime',
          type: 'text',
        },
        {
          key: 'buttons',
          titleBar: { title: 'message.tableCommon.operation', type: 'text' },
          type: 'operations',
          itemWidth: 200,
          subTableDisplays: [
            {
              type: 'text_button',
              textFunc: () => 'message.settlement.exportSettlementDetail',
              isDisplayFunc: (data) => data.payoutStatus !== 'F',
              permissionCode: 'settlement:disbursement:exportDetail',
              func: async (data) => {
                await this.downloadDisbursement({ payoutId: data.id });
                ShowSuccessMessage(this.$t('message.common.downloadTask'));
              },
            },
          ],
        },
      ],
      disbursementStatus: [],
    };
  },
  created() {
    getDictionary(['PAYOUT_STATUS']).then((res) => {
      this.searchCondition[1].options = initSelectedData(res.PAYOUT_STATUS.filter(item => {
        // 移除出款成功申报失败、已撤销、待审核、审核不通过、初始化、异常的状态
        return (item.value !== 'SF' && item.value !== 'C' &&
              item.value !== 'A' && item.value !== 'U' && item.value !== 'I' && item.value !== 'E');
      }));
    }).catch(() => {
    });
  },
  methods: {
    getInitParams() {
      const params = getTodayParams('createTimeStartTime', 'createTimeEndTime');
      return params;
    },
  },
};
</script>
